import React from "react";
import HybridConfig from "lib/HybridConfig";
import BroadcastServices from "lib/BroadcastServices";
import { appAlert } from "lib/withOver";
import usePeriodicTask from "lib/usePeriodicTask";

const DEFAULT_POLL_INTERVAL = 15 * 60 * 1000;

function BroadcastListener() {
    const [last, setLast] = React.useState(0);
    usePeriodicTask(
        () => {
            BroadcastServices.getMessages(last)
                .then(ms => {
                    if (ms.length === 0) return;
                    ms.sort((a, b) => b.activeAt - a.activeAt);
                    ms.forEach(m => appAlert(m.message));
                    setLast(ms[0].activeAt);
                });
        },
        HybridConfig.get(
            "broadcast.pollInterval",
            DEFAULT_POLL_INTERVAL,
        ),
        [last],
    );
    return null;
}

export default BroadcastListener;



// WEBPACK FOOTER //
// ./app/lib/broadcast/BroadcastListener.js